
// API Configuration
// This file centralizes the backend API URL configuration
// Automatically detects environment and sets appropriate API URL

// Smart API URL detection
const getApiBaseUrl = () => {
  // If REACT_APP_API_URL is explicitly set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Detect environment based on hostname
  const hostname = window.location.hostname;
  
  // Production server detection
  if (hostname === '3.110.248.134' || 
      hostname === 'publications.dbohra.com' || 
      hostname === 'publications.dbdea.org' ||
      hostname === 'your-domain.com') {
    // return 'http://3.110.248.134:5000';
    return 'https://publications.dbohra.com';
  }
  
  // Local development (localhost, 127.0.0.1, etc.)
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('192.168.')) {
    return 'http://localhost:5000';
  }
  
  // Default fallback for localhost
  return 'http://localhost:5000';
};

const API_BASE_URL = getApiBaseUrl();

// Debug logging (remove in production)
console.log('🌐 Environment Detection:');
console.log('  Hostname:', window.location.hostname);
console.log('  Full URL:', window.location.href);

console.log('  API Base URL:', API_BASE_URL);
console.log('  REACT_APP_API_URL:', process.env.REACT_APP_API_URL || 'Not set');

export const API_ENDPOINTS = {
  // Authentication
  LOGIN: `${API_BASE_URL}/api/auth/login`,
  REGISTER: `${API_BASE_URL}/api/auth/register`,
  PROFILE: `${API_BASE_URL}/api/auth/profile`,
  CHANGE_PASSWORD: `${API_BASE_URL}/api/auth/change-password`,
  
  // Admin endpoints
  USERS: `${API_BASE_URL}/api/admin/users`,
  ROLES: `${API_BASE_URL}/api/admin/roles`,
  DEPARTMENTS: `${API_BASE_URL}/api/admin/departments`,
  PUBLICATION_TYPES: `${API_BASE_URL}/api/admin/publication-types`,
  CATEGORIES: `${API_BASE_URL}/api/admin/categories`,
  DOCUMENT_TYPES: `${API_BASE_URL}/api/admin/document-types`,
  
  // Publications
  PUBLICATIONS: `${API_BASE_URL}/api/publications`,
  TEST_PUBLICATIONS: `${API_BASE_URL}/api/test-publications`,
  PUBLIC_PUBLICATION: `${API_BASE_URL}/api/publications/public`,
  
  // Public data
  PUBLICATION_TYPES_PUBLIC: `${API_BASE_URL}/api/publication-types`,
  CATEGORIES_PUBLIC: `${API_BASE_URL}/api/categories`,
  DOCUMENT_TYPES_PUBLIC: `${API_BASE_URL}/api/document-types`,
  
  // File uploads
  UPLOAD_IMAGE: `${API_BASE_URL}/api/upload-image`,
  UPLOAD_PDF: `${API_BASE_URL}/api/upload-pdf`,
  
  // Weekly Highlights
  WEEKLY_HIGHLIGHTS: `${API_BASE_URL}/api/weekly-highlights`,
  WEEKLY_HIGHLIGHTS_PUBLIC: `${API_BASE_URL}/api/weekly-highlights/public`,
  WEEKLY_HIGHLIGHT_PUBLIC: (identifier) => `${API_BASE_URL}/api/weekly-highlights/public/${identifier}`,
  
  // Statistics
  STATISTICS: `${API_BASE_URL}/api/statistics`,
  
  // File serving
  // UPLOADS: `${API_BASE_URL}/uploads`,
  UPLOADS: `/uploads`, // File serving - use relative URLs for images
  
  // Legal Documents Management
  LEGAL_DOCUMENTS: `${API_BASE_URL}/api/admin/legal-documents`,
  LEGAL_DOCUMENT_BY_ID: (id) => `${API_BASE_URL}/api/admin/legal-documents/${id}`,
  PUBLISH_LEGAL_DOCUMENT: (id) => `${API_BASE_URL}/api/admin/legal-documents/${id}/publish`,
  ARCHIVE_LEGAL_DOCUMENT: (id) => `${API_BASE_URL}/api/admin/legal-documents/${id}/archive`,
  
  // Public Legal Documents - Using URL slugs directly
  PUBLIC_PRIVACY_POLICY: `${API_BASE_URL}/api/privacy-policy`,
  PUBLIC_TERMS_OF_SERVICE: `${API_BASE_URL}/api/terms-and-conditions`,
  PUBLIC_LEGAL_DOCUMENT: (slug) => `${API_BASE_URL}/api/${slug}`,
  PUBLIC_LEGAL_DOCUMENT_LEGACY: (slug) => `${API_BASE_URL}/api/legal/${slug}`,
};

export default API_BASE_URL;
